import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const getNextSalesOrderNumberRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/sales-orders/next-number',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/sales-orders/next-number' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getNextSalesOrderNumberResponse: Json = {
    title: 'RESPONSE',
    json: {
        title: 'THE NEXT ORDER NUMBER OBJECT',
        json: {
            "orderNumber": "1005"
        },
    },
};

const data: RequestDefinitionData = {
    id: 'get-next-sales-order-number',
    title: 'Get the next sales order number',
    description: 'Returns the next available sales order number based on the system\'s auto-numbering settings. '
        + 'Note: calling this endpoint immediately consumes the order number — the number is incremented and '
        + 'reserved regardless of whether a sales order is subsequently created. '
        + 'Returns a 400 error if sales order auto-numbering is not enabled; in that case, enable it in the Module '
        + 'Options or supply the order number manually when creating a sales order.',
    endpoint: {
        verb: 'GET',
        path: '/sales-orders/next-number',
        tooltip: 'Get the next sales order number',
    },
    attributes: [],
    requestObject: getNextSalesOrderNumberRequest,
    responseObject: getNextSalesOrderNumberResponse,
};

export default data;